import React from 'react';
import '../Dashboard/MyGoals/MyGoals.css';
import '../Dashboard/MyGoals/TemplateGoals/Goal.css';
import { demoGoals } from './marketingDemoData';

function formatGoalDate(dateStr) {
    const date = new Date(dateStr);
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const da = String(date.getDate()).padStart(2, '0');
    const ye = date.getFullYear();
    return `${mo}/${da}/${ye}`;
}

/** Static V1 My Goals — Top 7 tab for marketing. */
const MarketingGoalsPreview = () => (
    <article className="myGoals marketing-goals">
        <div className="TitleDashboardContent">
            <p className="heading-5 BlueDarkText">MY GOALS</p>
        </div>
        <div className="myGoals__container">
            <ul className="myGoals__menu TitleMyGoal">
                <li>
                    <button type="button" className="firstTabMyGoal activeTab">
                        MY TOP 7
                    </button>
                </li>
                <li>
                    <button type="button">ACHIEVED</button>
                </li>
                <li>
                    <button type="button">ADDITIONAL</button>
                </li>
            </ul>
            <div className="MyGoalDefined__container">
                {demoGoals.map((item, index) => (
                    <div key={item.id}>
                        {item.isOneGoal ? (
                            <div className="titleMyOolaOne">MY OOLA ONE</div>
                        ) : null}
                        <article
                            className="goal"
                            style={{
                                backgroundColor: item.color,
                                color: 'white',
                                border: item.isOneGoal
                                    ? 'solid 3px var(--blue-light)'
                                    : `solid 2px ${item.color}`,
                                marginBottom: item.isOneGoal ? '23px' : '10px',
                                marginTop: item.isOneGoal ? '0px' : '10px',
                            }}
                        >
                            <div
                                className={
                                    item.isOneGoal
                                        ? 'goal__FNameOolaOne'
                                        : 'goal__FName'
                                }
                                style={{
                                    color: item.isOneGoal
                                        ? 'transparent'
                                        : item.color,
                                }}
                            >
                                {!item.isOneGoal ? (
                                    <h6 className="heading-6">
                                        {item.areaName.toUpperCase()}
                                    </h6>
                                ) : null}
                            </div>
                            <div className="goal__number">
                                <h3 className="heading-3">{index + 1}</h3>
                            </div>
                            <div className="goal__text">
                                <p className="paragraph-2">{item.text}</p>
                            </div>
                            <div className="goal__date">
                                <p className="paragraph-3">
                                    {formatGoalDate(item.completedByDate)}
                                </p>
                            </div>
                        </article>
                    </div>
                ))}
            </div>
        </div>
    </article>
);

export default MarketingGoalsPreview;
